const { default: Face } = require('./Face');

export default Face;
